<div class="container no-padding">
    <div class="row px-4 py-4">
      <a href="/" class="col-8">
        <img style="width: 148px;" src="../assets/logo-title.png">
      </a>
  
      <nav class="col-4" style="text-align: end;">
        <div>
            <!-- <button [matMenuTriggerFor]="beforeMenu"> -->
                <img style="width: 50px;cursor: pointer;" [matMenuTriggerFor]="beforeMenu" src="../../assets/profile-icon.png">
            <!-- </button> -->
                    <div>
                    
                        <mat-menu #beforeMenu="matMenu" xPosition="before"   style="width:22vw !important;">
                            <div fxLayout="column" fxLayoutAlign="center center"  fxLayoutGap="5px" style="margin-bottom: -8px;">
                                <div fxLayout="row" style="padding:10px 15px;"  fxLayoutGap="15px" fxLayoutAlign="center center"
                                    class="text-center">
                                    <img width="70" height="70" style="border-radius: 50px;" src="assets/profile-icon1.svg">
                                    <div fxLayout="column">
                                        <h6 class="user-name"> {{merchantDetails && merchantDetails.name}}</h6>
                                        <p class="user-email">{{merchantDetails && merchantDetails.email}}</p>
                                        <!-- <a class="checkDashboard-btn" >Check Dashboard</a> -->
                                    </div>
                                </div>
                    
                                <div fxLayout="column" fxFlex="10" style="background: #F9FAFF;padding:6%;width: 100%;">
                                    <button type="button" class="signout-btn" fxLayoutAlign="center center" (click)="logout()">Sign Out
                                    </button>
                                </div>
                            </div>
                        </mat-menu>
                    
                    </div>
        </div>
      </nav>
    </div>
    <router-outlet></router-outlet>
</div>